import { render } from "./zhuzhiyishi-news.vue?vue&type=template&id=42c3c5da&scoped=true"
import script from "./zhuzhiyishi-news.vue?vue&type=script&lang=js"
export * from "./zhuzhiyishi-news.vue?vue&type=script&lang=js"

import "./zhuzhiyishi-news.vue?vue&type=style&index=0&id=42c3c5da&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c3c5da"]])

export default __exports__